var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.09 70.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1c28;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #996875;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.05,
    cy: 35.05,
    r: 35.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.52,32.57c-2.23,0-4.53,1.45-6.99,4.42V15.71c0-.17-.06-.33-.16-.47l-.1-.13c-.14-.18-.35-.28-.58-.28h-1.11c-.2,0-.39.08-.53.22l-.13.13c-.14.14-.22.33-.22.52v36.34c0,.2.13.44.27.58.14.14.33.22.53.22.04,0,.07,0,.11,0,9.9-1.48,15.17-5.91,15.66-13.16,0-.04,0-.07,0-.11-.43-5.72-3.9-6.96-6.75-7ZM37.32,36.84c1.05.05,1.81.35,2.28.88.51.58.72,1.5.63,2.79,0,4.36-2.85,7.26-8.69,8.86v-7.45c2.22-3.32,4.23-5.07,5.79-5.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlats);
export default __webpack_public_path__ + "static/media/Flats.96c560c28bd461f46279c7a5250be904.svg";
export { ForwardRef as ReactComponent };